import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Button } from 'wanderu-components';
import { CloseX } from 'wanderu-icons';
import { generateIsomorphicID } from 'wanderu-utils';

import styles from './Tags.scss';

function Tag(props) {
    const {
        className,
        icon: Icon,
        text,
        onClick,
        disabled,
    } = props;

    function _onClick() {
        onClick();
    }

    return (
        <Button
            className={classNames(styles.tag, className)}
            disabled={disabled}
            onClick={_onClick}
            unstyled
        >
            {Icon && <Icon className={styles.icon} />}
            <span>
                {text}
            </span>
            {!disabled && <CloseX className={styles.tagButton} />}
        </Button>
    );
}

Tag.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.element,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};
Tag.defaultProps = {
    className: '',
    icon: null,
    text: '',
    disabled: false,
    onClick() {},
};

function Tags(props) {
    const {
        className,
        tags,
        disabled,
    } = props;

    return (
        <div className={`${styles.tags} ${className}`}>
            {tags.map((tag) => (
                <Tag
                    {...tag}
                    disabled={disabled}
                    key={generateIsomorphicID({ ...tag })}
                />
            ))}
        </div>
    );
}

Tags.propTypes = {
    className: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape(Tag.propTypes)),
    disabled: PropTypes.bool,
};
Tags.defaultProps = {
    className: '',
    tags: [],
    disabled: false,
};

export {
    Tag,
    Tags,
};
export default Tags;
